module.exports = __webpack_public_path__ + "static/media/Review2.7549166a.webp";